import { render, staticRenderFns } from "./DetallePrecalculo.vue?vue&type=template&id=6409a226&scoped=true"
import script from "./DetallePrecalculo.vue?vue&type=script&lang=js"
export * from "./DetallePrecalculo.vue?vue&type=script&lang=js"
import style0 from "./DetallePrecalculo.vue?vue&type=style&index=0&id=6409a226&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6409a226",
  null
  
)

export default component.exports